// this approximates the placement for a missing intervention based on ordering of interventions
// in the problems definitions, what appears in the log that is just before and just after
// the item to be inserted, and what is marked as required that is in the log just before and after.  An approach that
// utilizes partial ordering constraints would be better.  Also it is not clear what to do for really badly ordered
// actions on the part of the student.  Note that it only looks for two anchor points before and two anchor points after
// rather than all potential anchor points.  Also it does not deal with a phase that is split into multiple time periods
// within a log. It looks for the best placement in the last phase found.

//input orderedArrayObjects is the interventions for a problem as ordered in the problem def
// objIndex is the index in orderedArrayObjects for the intervention object that needs to be inserted in phases
export const insertInPhaseRelativeToSuggestedOrder = (phaseNames, phases, object, orderedArrayObjects, objIndex, confirmedEvents, checklistHierarchy, requiredPhaseNames, requiredSubphases, phaseRequiredAtEnd) => {
    // if expertPhase in object is a phase then find the last subphase and insert there instead of at the beginning
    let phaseIndex = -1;
    // if it is a subphase or a phase with no subphases then get the last entry for a proposed initial insertion point
    // object.expertPhase is the phase recommended for this action to appear
    if (object.expertPhase === ""){
        /* let errorMsg = 'No phase specified in the problem defs for object: ' + object.actionDescription;
        throw new Error(errorMsg) */
        //just use the next to last phase if none is specified
        object.expertPhase = requiredPhaseNames[requiredPhaseNames.length - 2]}


    if (requiredSubphases.includes(object.expertPhase) || !getSubPhases(object.expertPhase, checklistHierarchy)) {
        phaseIndex = phaseNames.lastIndexOf(object.expertPhase);
    }
    // if it is a phase then get the last entry of the last suphase within it for a proposed intial insertion point
    // for an intervention but if it is an assessment suggest goes in the first instance of the phase at the end of 
    // that phase
    else {
        phaseIndex = getEndSubPhaseIndex(object.expertPhase, phaseNames, checklistHierarchy);}
        /* if(["assessment", "required-action", "assessment-option"].includes(object.type)){
            phaseIndex = getFirstSubPhaseIndex(object.expertPhase, phaseNames)}
        else {phaseIndex = getEndSubPhaseIndex(object.expertPhase, phaseNames);}} */
    if (object.expertPhase === phaseRequiredAtEnd && phaseNames.length-1 !== phaseIndex){
        //add a phase ongoing management at the end
        phaseIndex = phaseNames.length
        phaseNames[phaseIndex] = phaseRequiredAtEnd;
        phases[phaseIndex] = []
    }

    //update object when field which is mostly to see what gets computed for the insertion point
    object.when = phaseNames[phaseIndex];

    let objectsBefore
    let objectBefore
    let requiredObjectBefore
    if (objIndex !== 0) {
        objectsBefore = orderedArrayObjects.slice(0, objIndex);
        objectBefore = [...objectsBefore].reverse().find(entry => confirmedEvents.includes(entry.id) || confirmedEvents.includes(entry.interventionID));
        requiredObjectBefore = objectsBefore.find(entry => ["required", "alternative"].includes(entry.protocolRelationship)  && confirmedEvents.includes(entry.interventionID))
    }
    let objectAfter 
    let objectsAfter
    let requiredObjectAfter 
    if (objIndex !== orderedArrayObjects.length-1) {
        objectsAfter = orderedArrayObjects.slice(objIndex + 1);
        objectAfter = [...objectsAfter].find(entry => confirmedEvents.includes(entry.id) || confirmedEvents.includes(entry.interventionID));
        requiredObjectAfter = objectsAfter.find(entry => ["required", "alternative"].includes(entry.protocolRelationship) && confirmedEvents.includes(entry.interventionID)) ;
    }
  
    let phaseObjects = [...phases[phaseIndex]]; //trying for a deep copy of the array mainly for debug via console.log
    
    let indexBefore = -1;
    let indexAfter = -1;
    let indexRequiredBefore = -1;
    let indexRequiredAfter = -1;
    let insertionIndex = false;
    if (objectBefore) { 
        indexBefore = phaseObjects.findIndex(entry => entry.id === objectBefore.id || entry.id === objectBefore.interventionID); 
    }
    if (objectAfter) { 
        indexAfter = phaseObjects.findIndex(entry => entry.id === objectAfter.id || entry.id === objectAfter.interventionID);
        }
    if (requiredObjectBefore) { 
        indexRequiredBefore = phaseObjects.findIndex(entry => entry.id === requiredObjectBefore.id || entry.id === requiredObjectBefore.interventionID); 
    }
    if (requiredObjectAfter) { 
        indexRequiredAfter = phaseObjects.findIndex(entry => entry.id === requiredObjectAfter.id || entry.id === requiredObjectAfter.interventionID); 
    }
    
    // There is a more compact way to do the below but this made
    // it easier for me to get the logic right
    // insert according to required before first as we want to follow something that was required
    if (indexRequiredBefore !== -1) {
        insertionIndex = indexRequiredBefore + 1;
        // but if the just before object is greater then insert relative to it
        if (!!indexBefore && indexBefore > indexRequiredBefore) { insertionIndex = indexBefore + 1; }
    }
    //if no required before and not required after then insert relative to
    //required item after in actions definition
    if (!insertionIndex && indexRequiredAfter !== -1) {
        insertionIndex = indexRequiredAfter - 1};
        // unless the just after is smaller then override and insert relative to it
        if (indexAfter < indexRequiredAfter) { insertionIndex = indexAfter - 1; }
    
    //otherwide if have a just before insert relative to it
    if (!insertionIndex && indexBefore !== -1) {
        insertionIndex = indexBefore + 1;
    }
    //otherwise if have a just after insert relative to it
    if (!insertionIndex && indexAfter !== -1) {
        insertionIndex = indexAfter - 1;
    }
    //otherwise put at end of phase
    if (!insertionIndex) {
        insertionIndex = phaseObjects.length + 1;
    }
    insertInPhaseInOrder(phaseNames, phases, object, insertionIndex);

};




//support functions for updating and searching the phaseNames and phases data structures
export const insertInPhaseInOrder = (phaseNames, phases, object, objIndex) => {
    let phase
    phase = object.when;  //what phase should it be added to
    let phaseIndex = phaseNames.lastIndexOf(phase); //get the index for the last instance of the phase
    let phaseObjects = phases[phaseIndex];  //get the objects associated with that phase
    if (!phaseObjects) { phaseObjects = []; }
    phaseObjects.splice(objIndex, 0, object);  //insert it at the place indicated by input objIndex
    phases[phaseIndex] = phaseObjects;
};

export const getEndSubPhase = (inPhaseId, phaseNames, checklistHierarchy) => {
    let subPhases = getSubPhases(inPhaseId, checklistHierarchy);
    let subPhaseName;
    let reversedSubPhases = [...subPhases].reverse();
    for (let subPhase of reversedSubPhases) {
        subPhaseName = phaseNames.find(id => id === subPhase.id);
        if (!!subPhaseName) { break; }
    }
    return subPhaseName;
};

export const getEndSubPhaseIndex = (inPhaseId, phaseNames, checklistHierarchy) => {
    let subPhaseName = getEndSubPhase(inPhaseId, phaseNames, checklistHierarchy);
    let index = phaseNames.lastIndexOf(subPhaseName);
    return index;
};

// sts 01/23/22
export const getSubPhases = (phaseId, checklistHierarchy) => {
    return checklistHierarchy.find(phase => phase.id === phaseId).subPhases
    // let mainPhases = findPhases();
    // let phaseEntry = mainPhases.find(phase => phase.id === phaseId);
    // return (phaseEntry.subPhases);
};

export const hasSubPhases = (phaseId, checklistHierarchy) => {
    let phase = checklistHierarchy.find(phase => phase.id === phaseId)
    if (!!phase && !!phase.subPhases){
        return true}
    else {return false}
}


//given a numerical id, what is its parent phase or subphase
//find the header under which the input numericalID appears
export const findHeaderFor = (numericalID, log) => {
    let candidateHeader = {};
    let foundHeader = {};
    for (let entry of log) {
        if (entry.id === "problemHeader") {
            candidateHeader = entry;
        }
        else {
            if (entry.numericalID === numericalID) {
                foundHeader = candidateHeader;
                break;
            }
        }
    }
    return (foundHeader);
};